import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import * as util from '../../../utils/EnumMapping';
import { TableContainer } from '../../common/table/TableContainer';
import NewCorrection from '../correction/NewCorrection';
import * as columns from './BalanceColumns';

class Balance extends Component {
    state = {
        partners: [],
        selectedPartner: {},
        balanceRows: [],
        isLoading: false,
    };

    refreshState() {
        console.log("refresh");
        this.loadData(this.state.selectedPartner);
    }

    loadData = async (partner) => {
        this.setState({ isLoading: true });

        try {
            const response = await this.callApi(partner);
            this.enrich(response.data.balance);
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "BALANCE";
            item.balanceRowTypeLabel = util.getLabel(util.balanceRowTypes, item.balanceRowType);
            item.inAmount=this.getAmount('IN', item.direction, item.amount);
            item.outAmount=this.getAmount('OUT', item.direction, item.amount);
            return item;
        })
        this.setState({ balanceRows: data })
    }

    getAmount(dir, direction, amount){
        if(dir===direction){
            return amount;
        } else {
            return '';
        }
    }

    callApi = async (partner) => {
        const path = '/api/balance';
        const requestObject = { "partnerType": partner.value.partnerType, "partnerId": partner.value.partnerId };
        return axios.post(path, requestObject);
    };

    promisePartnerOptions = async () => {
        const response = await axios.get('/api/balance')
        const renamedPartners = [];
        response.data.map((partner) =>
            renamedPartners.push({
                label: util.getLabel(util.partnerTypes, partner.partnerType) + ' - ' + partner.partnerName,
                value: partner,
            }));
        return renamedPartners;
    };

    handlePartnerSelected = (e, v) => {
        if (v) {
            this.setState({ selectedPartner: v })
            this.loadData(v);
        } else {
            this.setState({ selectedPartner: '', balanceRows: [] })
        }
    };

    render() {
        return (
            <div className="Balance">
                <section id="main-content">
                    <TableContainer columns={columns.columns(() => this.refreshState(), this.state.selectedPartner)}
                        data={this.state.balanceRows}
                        needGlobalfilter={true}
                        tableName='Egyenleg'
                        getBalancePartnerOptions={this.promisePartnerOptions}
                        onBalancePartnerChange={this.handlePartnerSelected}
                        dialogContent={(refresh, close) => <NewCorrection refresh={refresh} close={close} type={'BALANCE'} selectedPartner={this.state.selectedPartner} />}
                        newObjectLabel='Új korrekció hozzáadása'
                        refreshState={() => this.refreshState()}
                        isLoading={this.state.isLoading}
                    />
                </section>
            </div>
        );
    }
}
export default withSnackbar(Balance);
